<script setup>
import { ref, computed } from 'vue';

const emit = defineEmits(['click']);

const presetImages = [
  {
    id: 1,
    url: 'https://static.seedeai.com/templates/78c00590-75a5-45a7-a18c-6add915522ac_thumbnail.webp?v=1',
    alt: 'Preset 1',
    type: 'recommended',
  },
  {
    id: 2,
    url: 'https://static.seedeai.com/templates/02ed8cb1-a3c5-4d8a-8c1d-c99370bc1cf9_thumbnail.webp?v=3',
    alt: 'Preset 2',
    type: 'recommended',
  },
  {
    id: 3,
    url: 'https://static.seedeai.com/asset/f29faa19-6ff4-4873-852b-b487ad8c6308',
    alt: 'Preset 3',
    type: 'recommended',
  },
  {
    id: 4,
    url: 'https://static.seedeai.com/asset/a63e4a91-b1c3-4643-88e6-3efadf93c672',
    alt: 'Preset 4',
    type: 'recommended',
  },
  {
    id: 5,
    url: 'https://static.seedeai.com/templates/db83a39f-e92d-4159-8a67-b3889bc527c8_thumbnail.webp?v=1',
    alt: 'Preset 5',
    type: 'recommended',
  },
  {
    id: 6,
    url: 'https://static.seedeai.com/templates/92b2fcd4-03ff-4d96-8bf0-56157fc6a695_thumbnail.webp?v=1',
    alt: 'Preset 6',
    type: 'recommended',
  },
  {
    id: 7,
    url: 'https://static.seedeai.com/templates/e62fb96e-9ad0-496b-ad7e-3139ef3c3e32_thumbnail.webp?v=1',
    alt: 'Preset 1',
    type: 'creativeArt',
  },
  {
    id: 8,
    url: 'https://static.seedeai.com/templates/161fb357-156d-4333-9ea1-ce822d775cb1_thumbnail.webp?v=1',
    alt: 'Preset 1',
    type: 'creativeArt',
  },
  {
    id: 9,
    url: 'https://static.seedeai.com/templates/d98742a0-e0f0-4c49-a651-5fb658628cb2_thumbnail.webp?v=1',
    alt: 'Preset 1',
    type: 'creativeArt',
  },
];

const activeCategory = ref('recommended');
const categories = [
  'recommended',
  // "businessMarketing",
  // "techFuture",
  'creativeArt',
  // "luxuryElite",
  // "energyDynamic",
];

const list = computed(() => {
  const value = activeCategory.value;
  return presetImages.filter((item) => item.type === value);
});

function selectPresetImage(item) {
  emit('click', item);
}

function selectCategory(category) {
  activeCategory.value = category;
}
</script>

<template>
  <div class="flex-1 overflow-hidden">
    <div class="flex flex-col gap-2">
      <div class="flex items-center justify-center mb-2">
        <div class="inline-flex items-center gap-0 bg-black/5 rounded-full p-0.5">
          <div
            v-for="category in categories"
            :key="category"
            :class="[
              'px-2.5 py-1 text-xs font-normal cursor-pointer transition-all duration-200 rounded-full whitespace-nowrap',
              activeCategory === category
                ? 'bg-white text-black shadow-sm font-medium'
                : 'text-black/60 hover:text-black/80',
            ]"
            @click="selectCategory(category)"
          >
            {{ $t(`attach.Category.${category}`) }}
          </div>
        </div>
      </div>
    </div>
    <div class="relative h-28">
      <div class="absolute inset-0 overflow-x-auto scrollbar-hide">
        <div class="flex gap-3 px-2 pt-2 pb-0">
          <div
            v-for="preset in list"
            :key="preset.id"
            class="flex-shrink-0 h-fit w-20 rounded-xl overflow-hidden border border-black/10 cursor-pointer hover:shadow-md transition-all transform relative group"
            @click="selectPresetImage(preset)"
          >
            <img :src="preset.url" :alt="preset.alt" class="w-20 h-24 object-cover" />
            <div
              class="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center"
            >
              <span class="text-white text-xs font-medium p-2">{{
                $t('attach.selectMaterial')
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
